export interface TokenRefreshClient {
  updateToken: (minValidity: number) => Promise<boolean>;
  authenticated?: boolean;
}

/**
 * Proactively renews the Keycloak access token before it expires.
 *
 * keycloak-js 25 has no timer-based auto-refresh when checkLoginIframe is
 * disabled, so this interval is the primary renewal path: keep the token
 * fresh with 60s of remaining validity. Failures are ignored silently — a
 * dead session must never trigger a logout from a background refresh; the
 * axios 401 interceptor remains the last-resort fallback.
 *
 * @returns a cleanup function that stops the interval.
 */
export function scheduleTokenRefresh(kc: TokenRefreshClient, intervalMs = 60_000): () => void {
  const timer = window.setInterval(() => {
    if (!kc.authenticated) return;
    kc.updateToken(60).catch(() => {
      // Ignore: refresh token revoked or session dead. The 401 flow handles it.
    });
  }, intervalMs);
  return () => window.clearInterval(timer);
}
